import guest from './rules/guest';
import user from './rules/user';
import canView from './rules/canView';
import canAnswer from './rules/canAnswer';
import canCreate from './rules/canCreate';
import canEdit from './rules/canEdit';
import canDelete from './rules/canDelete';
import canViewRolesSuperAdmin from './rules/canViewRolesSuperAdmin';
import canCreateRolesSuperAdmin from './rules/canCreateRolesSuperAdmin';
import canEditRolesSuperAdmin from './rules/canEditRolesSuperAdmin';

import canViewRolesAdmin from './rules/canViewRolesAdmin';
import canCreateRolesAdmin from './rules/canCreateRolesAdmin';
import canEditRolesAdmin from './rules/canEditRolesAdmin';

import canCreateSuperUser from './rules/canCreateSuperUser';
import canEditSuperUser from './rules/canEditSuperUser';
import notFoundHandler from './rules/notFoundHandler';
import canReadCompetition from "@/middleware/rules/canReadCompetition";
import canReadTraining from "@/middleware/rules/canReadTraining";
import canReadScore from "@/middleware/rules/canReadScore";

export default {
    guest, user, canView, canCreate, canEdit, canDelete, canAnswer,
    canViewRolesSuperAdmin, canCreateRolesSuperAdmin,
    canEditRolesSuperAdmin, canViewRolesAdmin,
    canCreateRolesAdmin, canEditRolesAdmin,
    notFoundHandler, canCreateSuperUser, canEditSuperUser,
    canReadCompetition, canReadTraining, canReadScore
}